var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnCon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#FF4848"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69 12.18H9.81V14.44H11.13V7.65H9.81V9.26H8.69V10.32H9.81V11.12H8.69V12.18ZM8.71 13.01L8.63 12.05C8.36 12.08 8.08 12.1 7.79 12.13V9.36H8.52V8.31H3.66V9.36H4.39V12.26H3.43L3.57 13.33C5.01 13.33 7.01 13.3 8.71 13.01ZM5.66 12.23V9.36H6.52V12.21C6.23 12.22 5.94 12.23 5.66 12.23ZM11.34 16.7V15.65H6.38V13.93H5.06V16.7H11.34ZM19.8092 16.88V7.64H18.4892V16.88H19.8092ZM15.0892 8.26C13.6492 8.26 12.5592 9.21 12.5592 10.53C12.5592 11.85 13.6492 12.8 15.0892 12.8C16.5292 12.8 17.6292 11.85 17.6292 10.53C17.6292 9.21 16.5292 8.26 15.0892 8.26ZM15.0892 9.39C15.8092 9.39 16.3392 9.81 16.3392 10.53C16.3392 11.25 15.8092 11.67 15.0892 11.67C14.3692 11.67 13.8392 11.25 13.8392 10.53C13.8392 9.81 14.3692 9.39 15.0892 9.39ZM12.1692 13.94L12.3392 15.01C13.9292 15.01 16.0892 14.99 18.0692 14.59L17.9892 13.64C16.0492 13.93 13.7892 13.94 12.1692 13.94Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCon);
export default __webpack_public_path__ + "static/media/btnCon.f04a3071e960e8e66f7ccf658fa8c6f9.svg";
export { ForwardRef as ReactComponent };